// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomChangeToText = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M17.7562 15.6172C17.5285 15.8579 17.5391 16.2377 17.7799 16.4654C18.0206 16.6931 18.4004 16.6825 18.6281 16.4417L17.7562 15.6172ZM19 8L19.5128 7.68853L19 8ZM9.49761 5.59375C9.2633 5.82806 9.2633 6.20796 9.49761 6.44228L13.316 10.2607C13.5503 10.495 13.9302 10.495 14.1645 10.2607C14.3988 10.0263 14.3988 9.64644 14.1645 9.41213L10.7704 6.01801L14.1645 2.6239C14.3988 2.38959 14.3988 2.00969 14.1645 1.77537C13.9302 1.54106 13.5503 1.54106 13.316 1.77537L9.49761 5.59375ZM18.6281 16.4417C20.117 14.8674 21.7338 11.3453 19.5128 7.68853L18.4872 8.31147C20.3357 11.3549 19.0112 14.2902 17.7562 15.6172L18.6281 16.4417ZM19.5128 7.68853C18.2992 5.6904 16.2302 5.16588 14.3738 5.1031C13.4407 5.07154 12.5263 5.15448 11.7478 5.24158C10.9392 5.33205 10.3347 5.41801 9.92188 5.41801L9.92187 6.61801C10.4236 6.61801 11.1468 6.51631 11.8812 6.43413C12.6459 6.34858 13.49 6.27389 14.3332 6.30241C16.0297 6.35979 17.5851 6.82626 18.4872 8.31147L19.5128 7.68853Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.6902 21.9372C10.6902 22.1115 10.5489 22.2529 10.3745 22.2529H9.41902C9.24466 22.2529 9.10332 22.1115 9.10332 21.9372V14.511C9.10332 14.3366 8.96198 14.1953 8.78763 14.1953H5.3157C5.14134 14.1953 5 14.0539 5 13.8796V12.9925C5 12.8181 5.14134 12.6768 5.3157 12.6768H14.1552C14.3295 12.6768 14.4709 12.8181 14.4709 12.9925V13.8796C14.4709 14.0539 14.3295 14.1953 14.1552 14.1953H11.0059C10.8316 14.1953 10.6902 14.3366 10.6902 14.511V21.9372Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomChangeToText };
